/**
 * PropertyCardManager — Manages expand/collapse behavior of all property cards.
 *
 * Ensures only one card can be in full-space mode at a time.
 * Also handles the ESC key to close expanded cards.
 */
export default class PropertyCardManager {
  constructor() {
    this.activeCard = null;

    // ESC key closes expanded card
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.activeCard) {
        this._collapseAll();
      }
    });

    // Click outside expanded card closes it
    document.addEventListener('click', (e) => {
      if (this.activeCard && !this.activeCard.contains(e.target)) {
        this._collapseAll();
      }
    });
  }

  _collapseAll() {
    const allCards = document.querySelectorAll('.property-card');
    allCards.forEach(card => {
      card.style.display = '';
      card.classList.remove('full-space', 'expanded');
      const options = card.querySelector('.property-options');
      if (options) options.classList.add('hidden');
    });
    this.activeCard = null;
  }

  setActive(card) {
    this.activeCard = card;
  }

  clearActive() {
    this.activeCard = null;
  }
}
